// 租金模式
export var RentalModel;
(function (RentalModel) {
    RentalModel[RentalModel["Fixed"] = 1] = "Fixed";
    RentalModel[RentalModel["Reduce"] = 2] = "Reduce";
})(RentalModel || (RentalModel = {}));
// 亚瑟士表单时选择的品牌列表类型
// 1: "国际一线奢侈品牌",2: "国际二线奢侈品牌",3: "运动品牌",4: "优质零售品牌",5: "优质零售集合店",6: "儿童运动品牌",7: "优秀儿童零售品牌",8: "竞品品牌", 9: "优秀儿童游乐品牌"
export var AsicsBrandType;
(function (AsicsBrandType) {
    AsicsBrandType[AsicsBrandType["InterFirLuxuryBrand"] = 1] = "InterFirLuxuryBrand";
    AsicsBrandType[AsicsBrandType["InterSecLuxuryBrand"] = 2] = "InterSecLuxuryBrand";
    AsicsBrandType[AsicsBrandType["SportBrand"] = 3] = "SportBrand";
    AsicsBrandType[AsicsBrandType["ExcellentRetailBrand"] = 4] = "ExcellentRetailBrand";
    AsicsBrandType[AsicsBrandType["ExcellentRetailStore"] = 5] = "ExcellentRetailStore";
    AsicsBrandType[AsicsBrandType["KidSportBrand"] = 6] = "KidSportBrand";
    AsicsBrandType[AsicsBrandType["ExcellentKidRetailBrand"] = 7] = "ExcellentKidRetailBrand";
    AsicsBrandType[AsicsBrandType["SignedCompeteBrand"] = 8] = "SignedCompeteBrand";
    AsicsBrandType[AsicsBrandType["ExcellentKidAmusementBrand"] = 9] = "ExcellentKidAmusementBrand"; // 优秀儿童游乐品牌
})(AsicsBrandType || (AsicsBrandType = {}));
// 数组index映射的是AsicsBrandType，所以下面定义的顺序不要随便更改
export var asicsBrandTypeNames = [
    { key: 'interFirLuxuryBrand', name: '国际一线奢侈品牌' },
    { key: 'interSecLuxuryBrand', name: '国际二线奢侈品牌' },
    { key: 'sportBrand', name: '运动品牌' },
    { key: 'excellentRetailBrand', name: '优质零售品牌' },
    { key: 'excellentRetailStore', name: '优质零售集合店' },
    { key: 'kidSportBrand', name: '儿童运动品牌' },
    { key: 'excellentKidRetailBrand', name: '优秀儿童零售品牌' },
    { key: 'signedCompeteBrand', name: '竞品品牌' },
    { key: 'excellentKidAmusementBrand', name: '优秀儿童游乐品牌' },
];
// 存储选中的品牌的Map结构的数据
export var asicsBrandGather = new Map([
    [AsicsBrandType.InterFirLuxuryBrand, []],
    [AsicsBrandType.InterSecLuxuryBrand, []],
    [AsicsBrandType.SportBrand, []],
    [AsicsBrandType.ExcellentRetailBrand, []],
    [AsicsBrandType.ExcellentRetailStore, []],
    [AsicsBrandType.KidSportBrand, []],
    [AsicsBrandType.ExcellentKidRetailBrand, []],
    [AsicsBrandType.SignedCompeteBrand, []],
    [AsicsBrandType.ExcellentKidAmusementBrand, []],
]);
